import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=8ddb25ec&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddb25ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ddb25ec')) {
      api.createRecord('8ddb25ec', component.options)
    } else {
      api.reload('8ddb25ec', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=8ddb25ec&scoped=true&", function () {
      api.rerender('8ddb25ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V55pcmypI443/JS/comp/Accordion.vue"
export default component.exports